import { Http } from '@/lib/http';

export class IdTypeService extends Http {
  endpoint = 'onboarder/settings/id-types';
  constructor() {
    super();
  }

  fetchIdTypes() {
    return this.httpClient().get(this.endpoint);
  }

  updateIdType(id, updates) {
    return this.httpClient().patch(`${this.endpoint}/${id}`, updates);
  }

  createIdType(idType) {
    return this.httpClient().post(this.endpoint, idType);
  }

  deleteIdType(id) {
    return this.httpClient().delete(`${this.endpoint}/${id}`);
  }
}
